// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared mobile row popup — popup when table has more than 6 columns / field rows; ≤6 no popup */

.orders-mrp-card {
  overflow: hidden;
}

/* Mobile order cards — white panel, pair + side/type hero, KV rows */
.orders-mobCard {
  color: #1e2329;
  border-radius: 0px;
  overflow: hidden;
  margin-bottom: 12px;
  box-shadow: none;
  padding: 0px;
}

.so-mobileCard {
  /* border-bottom: 1px solid #efefef;
  padding-bottom: 8px; */
}

.orders-mobCard__hero {
  padding: 5px 0 0px;
  /* border-bottom: 1px solid #f0f2f5; */
  margin-bottom: 2px;
}

.orders-mobCard__pairLine {
  display: flex;
  align-items: center;
  gap: 4px;
}

.orders-mobCard__pair {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  letter-spacing: -0.02em;
}

body.light_theme .orders-mobCard__pair {
  color: #0b0e11;
}

.orders-mobCard__chev {
  font-size: 18px;
  color: #b7bdc6;
  font-weight: 400;
  line-height: 1;
}

.orders-mobCard__datetime {
  margin-top: 4px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.35;
  color: #707a8a;
}

.orders-mobCard__subtypeRow {
  margin-top: 2px;
}

.orders-mobCard__subtype {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.35;
}

.orders-mobCard__subtype--buy {
  color: #0ecb81;
}

.orders-mobCard__subtype--sell {
  color: #f6465d;
}

.orders-mobCard__body--plain .so-mobileCard__row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 5px 0;
  font-size: 13px;
  border-bottom: none;
}

ul.so-dd__menu.so-dd__menu--tiles {
  left: 0px;
}

.orders-mobCard__body--plain .so-mobileCard__row span:first-child {
  color: #707a8a;
  font-weight: 400;
  flex-shrink: 0;
}

.orders-mobCard__body--plain .so-mobileCard__row span:last-child {
  text-align: right;
  color: #e5e5e5;
  flex-direction: row;
}

body.light_theme .orders-mobCard__body--plain .so-mobileCard__row span:last-child {
  color: #1e2329;
}

/* Tap hero + preview rows to open full detail sheet (when 7+ cols & 7+ rows). */
.orders-mobCard__tapZone {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.orders-mobCard__tapZone:focus-visible {
  outline: 2px solid #f0b90b;
  outline-offset: 2px;
  border-radius: 8px;
}

.orders-mobCard__statusVal {
  color: #98a2b3 !important;
}

.orders-mobCard .so-mobileCard__actions {
  margin-top: 0px;
  padding-top: 2px;
}

.orders-mrp {
  position: fixed;
  inset: 0;
  z-index: 999999999;
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 0px;
  /* border-radius: 0px; */
  padding-bottom: 0px;
  box-sizing: border-box;
}

.orders-mrp__backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.45);
  -webkit-tap-highlight-color: transparent;
}

.orders-mrp__panel {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 100%;
  min-height: 100%;
  max-height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  animation: orders-mrp-pop 0.2s ease-out;
}

.orders-mrp__panel--light {
  background: #000000;
  color: #ebebeb;
}

body.light_theme .orders-mrp__panel--light {
  background: #ffffff;
  color: #1e2329;
}

@keyframes orders-mrp-pop {
  from {
    transform: scale(0.96);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.orders-mrp__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 16px 16px 5px;
}

.orders-mrp__title {
  font-size: 17px;
  font-weight: 600;
  padding-right: 8px;
}

.orders-mrp__close {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  -webkit-tap-highlight-color: transparent;
}

.orders-mrp__close::before,
.orders-mrp__close::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 20px;
  height: 2px;
  background: #454647;
  border-radius: 1px;
}

.orders-mrp__close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.orders-mrp__close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.orders-mrp__body {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.orders-mrp__detailInner {
  padding: 8px 16px 4px;
}

/* Light modal: hero + rows match card */
.orders-mrp__panel--light .orders-mrp__detailInner .orders-mobCard__hero {
  padding-top: 4px;
}

.orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row {
  border-color: transparent;
  font-size: 14px;
}

.orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row span:first-child {
  color: #707a8a;
}

.orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row span:last-child {
  color: #e0e0e0;
}

body.light_theme .orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row span:last-child {
  color: #1e2329;
}

.orders-mrp__actionsSlot {
  padding: 0px 16px 0px;
}

.orders-mrp__actionsSlot .so-mobileCard__actions {
  margin: 0;
}

.orders-mrp__footer {
  flex-shrink: 0;
  margin-top: auto;
  padding: 16px 16px 12px;
  padding-bottom: max(16px, env(safe-area-inset-bottom));
  background: #000000;
}

body.light_theme .orders-mrp__footer {
  background: #ffffff;
}

.orders-mrp__ok {
  display: block;
  width: 100%;
  padding: 11px 16px;
  margin: 0;
  border: none;
  border-radius: 50px;
  background: #111827;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.orders-mrp__ok:focus-visible {
  outline: 2px solid #1e2329;
  outline-offset: 2px;
}

.orders-mrp__ok:active {
  filter: brightness(0.95);
}


ul.so-dd__menu.so-dd__menu--tiles {
  flex-wrap: nowrap;
}


@media screen and (max-width: 767px) {

  .orders-mrp__ok {
    padding: 9px 16px;
    font-size: 12px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Order/orderMobileRowPopup.css"],"names":[],"mappings":"AAAA,iGAAiG;;AAEjG;EACE,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;wBACsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,SAAW;EACX,aAAa;EACb,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,iBAAiB;AACnB;;;AAGA;;EAEE;IACE,iBAAiB;IACjB,eAAe;EACjB;;AAEF","sourcesContent":["/* Shared mobile row popup — popup when table has more than 6 columns / field rows; ≤6 no popup */\n\n.orders-mrp-card {\n  overflow: hidden;\n}\n\n/* Mobile order cards — white panel, pair + side/type hero, KV rows */\n.orders-mobCard {\n  color: #1e2329;\n  border-radius: 0px;\n  overflow: hidden;\n  margin-bottom: 12px;\n  box-shadow: none;\n  padding: 0px;\n}\n\n.so-mobileCard {\n  /* border-bottom: 1px solid #efefef;\n  padding-bottom: 8px; */\n}\n\n.orders-mobCard__hero {\n  padding: 5px 0 0px;\n  /* border-bottom: 1px solid #f0f2f5; */\n  margin-bottom: 2px;\n}\n\n.orders-mobCard__pairLine {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.orders-mobCard__pair {\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  letter-spacing: -0.02em;\n}\n\nbody.light_theme .orders-mobCard__pair {\n  color: #0b0e11;\n}\n\n.orders-mobCard__chev {\n  font-size: 18px;\n  color: #b7bdc6;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.orders-mobCard__datetime {\n  margin-top: 4px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.35;\n  color: #707a8a;\n}\n\n.orders-mobCard__subtypeRow {\n  margin-top: 2px;\n}\n\n.orders-mobCard__subtype {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.35;\n}\n\n.orders-mobCard__subtype--buy {\n  color: #0ecb81;\n}\n\n.orders-mobCard__subtype--sell {\n  color: #f6465d;\n}\n\n.orders-mobCard__body--plain .so-mobileCard__row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 5px 0;\n  font-size: 13px;\n  border-bottom: none;\n}\n\nul.so-dd__menu.so-dd__menu--tiles {\n  left: 0px;\n}\n\n.orders-mobCard__body--plain .so-mobileCard__row span:first-child {\n  color: #707a8a;\n  font-weight: 400;\n  flex-shrink: 0;\n}\n\n.orders-mobCard__body--plain .so-mobileCard__row span:last-child {\n  text-align: right;\n  color: #e5e5e5;\n  flex-direction: row;\n}\n\nbody.light_theme .orders-mobCard__body--plain .so-mobileCard__row span:last-child {\n  color: #1e2329;\n}\n\n/* Tap hero + preview rows to open full detail sheet (when 7+ cols & 7+ rows). */\n.orders-mobCard__tapZone {\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.orders-mobCard__tapZone:focus-visible {\n  outline: 2px solid #f0b90b;\n  outline-offset: 2px;\n  border-radius: 8px;\n}\n\n.orders-mobCard__statusVal {\n  color: #98a2b3 !important;\n}\n\n.orders-mobCard .so-mobileCard__actions {\n  margin-top: 0px;\n  padding-top: 2px;\n}\n\n.orders-mrp {\n  position: fixed;\n  inset: 0;\n  z-index: 999999999;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  padding: 0px;\n  /* border-radius: 0px; */\n  padding-bottom: 0px;\n  box-sizing: border-box;\n}\n\n.orders-mrp__backdrop {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  background: rgba(0, 0, 0, 0.45);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.orders-mrp__panel {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 100%;\n  min-height: 100%;\n  max-height: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  border-radius: 0px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);\n  animation: orders-mrp-pop 0.2s ease-out;\n}\n\n.orders-mrp__panel--light {\n  background: #000000;\n  color: #ebebeb;\n}\n\nbody.light_theme .orders-mrp__panel--light {\n  background: #ffffff;\n  color: #1e2329;\n}\n\n@keyframes orders-mrp-pop {\n  from {\n    transform: scale(0.96);\n    opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.orders-mrp__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n  padding: 16px 16px 5px;\n}\n\n.orders-mrp__title {\n  font-size: 17px;\n  font-weight: 600;\n  padding-right: 8px;\n}\n\n.orders-mrp__close {\n  width: 36px;\n  height: 36px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  position: relative;\n  flex-shrink: 0;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.orders-mrp__close::before,\n.orders-mrp__close::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 20px;\n  height: 2px;\n  background: #454647;\n  border-radius: 1px;\n}\n\n.orders-mrp__close::before {\n  transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.orders-mrp__close::after {\n  transform: translate(-50%, -50%) rotate(-45deg);\n}\n\n.orders-mrp__body {\n  flex: 1 1 0;\n  min-height: 0;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.orders-mrp__detailInner {\n  padding: 8px 16px 4px;\n}\n\n/* Light modal: hero + rows match card */\n.orders-mrp__panel--light .orders-mrp__detailInner .orders-mobCard__hero {\n  padding-top: 4px;\n}\n\n.orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row {\n  border-color: transparent;\n  font-size: 14px;\n}\n\n.orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row span:first-child {\n  color: #707a8a;\n}\n\n.orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row span:last-child {\n  color: #e0e0e0;\n}\n\nbody.light_theme .orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row span:last-child {\n  color: #1e2329;\n}\n\n.orders-mrp__actionsSlot {\n  padding: 0px 16px 0px;\n}\n\n.orders-mrp__actionsSlot .so-mobileCard__actions {\n  margin: 0;\n}\n\n.orders-mrp__footer {\n  flex-shrink: 0;\n  margin-top: auto;\n  padding: 16px 16px 12px;\n  padding-bottom: max(16px, env(safe-area-inset-bottom));\n  background: #000000;\n}\n\nbody.light_theme .orders-mrp__footer {\n  background: #ffffff;\n}\n\n.orders-mrp__ok {\n  display: block;\n  width: 100%;\n  padding: 11px 16px;\n  margin: 0;\n  border: none;\n  border-radius: 50px;\n  background: #111827;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.orders-mrp__ok:focus-visible {\n  outline: 2px solid #1e2329;\n  outline-offset: 2px;\n}\n\n.orders-mrp__ok:active {\n  filter: brightness(0.95);\n}\n\n\nul.so-dd__menu.so-dd__menu--tiles {\n  flex-wrap: nowrap;\n}\n\n\n@media screen and (max-width: 767px) {\n\n  .orders-mrp__ok {\n    padding: 9px 16px;\n    font-size: 12px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
